import { render } from "./background_app.vue?vue&type=template&id=418385f3"
import script from "./background_app.vue?vue&type=script&lang=js"
export * from "./background_app.vue?vue&type=script&lang=js"

import "./background_app.vue?vue&type=style&index=0&id=418385f3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__